<div class="input-toggle" [class.input-toggle-disabled]="control?.disabled">
    <span>
      <label style="text-transform: uppercase" (click)="toggle($event)"
        ><ng-content></ng-content
      ></label>
      <i
        style="padding-left: 5px; padding-bottom: 10px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip && useIconToolTip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </span>
    <label
      class="toggle-switch"
      tooltipPosition="top"
      pTooltip="{{ tooltip }}"
      [tooltipOptions]="{ disabled: !tooltip || useIconToolTip }"
    >
      <input
        style="cursor: pointer"
        type="checkbox"
        [formControl]="control"
        [checked]="control?.value"
        (click)="toggle($event)"
      />
      <span class="slider"></span>
      <span class="toggle-text on-text text-link-color" *ngIf="control?.value"
        >On</span
      >
      <span class="toggle-text off-text" *ngIf="!control?.value">Off</span>
    </label>
  </div>
  